import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Card, Tabs ,Tooltip} from 'antd';
import VerificationCode from '../../Login/VerificationCode';
import Password from '../../Login/Password';
import ForgetPassword from '../../Login/ForgetPassword';
import s from './style.m.less';
import withRouter from '@/components/withRouter';
import theme_bg from '@/assets/images/wcb/theme_bg.webp';
// import org_logo from '@/assets/images/wcb/org_logo.webp';
import GrtLoading from '@/components/GrtLoading/GRTLoading';
import sub_org_logo from '@/assets/images/wcb/sub_org_logo.webp';
import ImageRender from '@/components/GrtImage/ImageRender';
@inject('store')
@observer
class Wcb extends Component {
    state = {
        loading: true
    };
    async componentDidMount() {
        const {
            store: { login }
        } = this.props;
        login.setRedirectUrl(`https://${window.location.host}/web/wcb_tenant`);

        const isLogin = await login.checkLogin();
        if (isLogin) {
            return login.loginCallback(null,'competition');
        }
        this.setState({
            loading: false
        });
    }

    onChange = (activeKey) => {
        const {
            store: { login }
        } = this.props;

        login.setActiveKey(activeKey);
    };

    render() {
        const {
            store: { login }
        } = this.props;
        return (
            <>
                {
                    this.state.loading ?
                    <GrtLoading />
                    :
                    <div className={s.competition_app}>
                        <div style={{display: 'flex', justifyContent: 'center' }}>
                            <div style={{ width: '1200px' }}>
                                <div className={s.org_logo}>
                                    <ImageRender src={sub_org_logo} style={{height:'66px'}}/>
                                </div>
                                <div className={s.competition_content}>
                                    <div style={{display:'flex',justifyContent:'center'}}>
                                        <div className={s.left_wrap}>
                                            <div className={s.logo_wrap}>
                                                <ImageRender src={theme_bg} alt=''/>
                                            </div>
                                            <div className={s.handler_wrap}>
                                                <a className={s.btn} rel="noreferrer"
                                                    href='https://apaas.grtcloud.net/preview/onlinePreview?url=aHR0cHM6Ly90dGNkdzYtb3Blbi5vYnMuY24tbm9ydGgtNC5teWh1YXdlaWNsb3VkLmNvbS8xNzcwNzY4NTk2NDk0MDEyNDE3LzBmZjVhODRiMGMzNjRjOWQyMjIyNjg2OGQxMTBiMDM3LnBkZg'
                                                    target='_blank'>
                                                    {'查看展演活动方案 >'}
                                                </a>
                                                <Tooltip title={'暂未开始'}>
                                                    <a className={s.btn}>
                                                        {'展演方案说明直播 >'}
                                                    </a>
                                                </Tooltip>
                                            </div>
                                        </div>
                                        <div className={s.right_wrap}>
                                            <Card hoverable>
                                                {login.mode === 'login' ? (
                                                    <Tabs
                                                        onChange={this.onChange}
                                                        activeKey={login.activeKey}
                                                        items={[
                                                            {
                                                                key: 'code',
                                                                label: '验证码登录',
                                                                children: <VerificationCode type="competition" />
                                                            },
                                                            {
                                                                key: 'password',
                                                                label: '密码登录',
                                                                children: <Password type="competition" />
                                                            }
                                                        ]}
                                                    />
                                                ) : (
                                                    <ForgetPassword type="competition" />
                                                )}
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={s.footer}>
                            <div
                                style={{
                                    width: '1200px',
                                    height: '92px',
                                    margin: '0 auto',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between'
                                }}
                            >
                                <div className={s.footer_text}>
                                    <div style={{ marginBottom: '8px' }}>
                                        主办单位：北京教育学院人文与外语教育学院 <span style={{ marginLeft: '40px', display: 'inline-block' }}>教育戏剧研究中心</span>
                                    </div>
                                    <div>技术支持：北京国人通教育科技有限公司</div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </>
        );
    }
}
export default withRouter(Wcb);